import type { FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const SatNoteDelayed: FunctionComponent = () => (
  <PleaseWaitOverlay
    icon="check-circle-color"
    title="You have signed your satisfaction note"
    labelLine1="We have received your satisfaction note. However, the processing of it has been delayed. This will be either because we have tried to reach out to you unsuccessfully or the bank is holding up approval."
    labelLine2="If you have been asked to sign the satisfaction note again by your tradesperson, rest assured you do not need to take further action."
    labelLine3={
      <p>
        If you&apos;re having trouble, you can reach out to Ideal4Finance loans
        team directly by clicking the{' '}
        <span className="font-semibold">&quot;Need Help&quot;</span> button in
        the header and calling our loans applications team to get some advice.
      </p>
    }
  />
);

export default SatNoteDelayed;
